import o from "./ghl-ui.es1505.js";
import n from "./ghl-ui.es1506.js";
import i from "./ghl-ui.es1466.js";
function s(e, a) {
  i(2, arguments);
  var t = n(e), r = o(a);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && t.setDate(t.getDate() + r), t);
}
export {
  s as default
};
